module.exports = __webpack_public_path__ + "img/check.5dd2806f.svg";